export default {
  'pages.marketingCampaigns.title': 'Marketing Campaigns (Migrated)',
  'pages.marketingCampaigns.name': 'Title',
  'pages.marketingCampaigns.id': 'Campaign ID',
  'pages.marketingCampaigns.creationDate': 'Creation date',
  'pages.marketingCampaigns.startDateFilter': 'Start date',
  'pages.marketingCampaigns.expiryDateFilter': 'Expiry date',
  'pages.marketingCampaigns.status': 'Status',
  'pages.marketingCampaigns.active': 'Active',
  'pages.marketingCampaigns.inactive': 'Inactive',
  'pages.marketingCampaigns.code': 'Promo code',
  'pages.marketingCampaigns.start': 'Start date and time',
  'pages.marketingCampaigns.expiry': 'Expiry date and time',
  'pages.marketingCampaigns.benefit': 'Benefit',
  'pages.marketingCampaigns.discount': 'Discount',
  'pages.marketingCampaigns.capping': 'Capping (EGP)',
  'pages.marketingCampaigns.deactivationDate': 'Deactivation date',
  'pages.marketingCampaigns.reason': 'Deactivation reason',
  'pages.marketingCampaigns.actions': 'Actions',
  'pages.marketingCampaigns.edit': 'Edit campaign',
  'pages.marketingCampaigns.deactivate': 'Deactivate campaign',
  'pages.marketingCampaigns.deactivateTitle': 'Deactivate Campaign',
  'pages.marketingCampaigns.deactivateConfirmation':
    'Are you sure you want to deactivate this campaign?',
  'pages.marketingCampaigns.confirm': 'Confirm',
  'pages.marketingCampaigns.cancel': 'Cancel',
  'pages.marketingCampaigns.reactivate': 'Reactivate campaign',
  'pages.marketingCampaigns.export': 'Export promo codes',
  'pages.marketingCampaigns.searchText': 'Search',
  'pages.marketingCampaigns.searchHint': 'Name, ID, promo code',
  'pages.marketingCampaigns.moreActions': 'More actions',
  'pages.marketingCampaigns.currentCampaign': 'Current campaign details',
  'pages.marketingCampaigns.maxUsesMinimum':
    'Campaign usage limit must be at least 1',
  'pages.marketingCampaigns.prefixHint': 'Use up to 3 letters or numbers',
  'pages.marketingCampaigns.fees': 'Discount on circle fees',
  'pages.marketingCampaigns.installments': 'Discount on installments',
  'pages.marketingCampaigns.search': 'Search',
  'pages.marketingCampaigns.clear': 'Clear',
  'pages.marketingCampaigns.create': 'Create campaign',
  'pages.marketingCampaigns.saved': 'Campaign saved successfully',
  'pages.marketingCampaigns.failed': 'Campaign request failed',
  'pages.marketingCampaigns.eligibility': 'User eligibility',
  'pages.marketingCampaigns.allUsers': 'All users',
  'pages.marketingCampaigns.uploadUsers': 'Upload a list of users',
  'pages.marketingCampaigns.filters': 'Filters',
  'pages.marketingCampaigns.userTypes': 'User types',
  'pages.marketingCampaigns.individual': 'Individual',
  'pages.marketingCampaigns.corporate': 'Corporate salary deduction',
  'pages.marketingCampaigns.selfPay': 'Corporate self pay',
  'pages.marketingCampaigns.segments': 'User segments',
  'pages.marketingCampaigns.newUsers': 'New users',
  'pages.marketingCampaigns.retainedUsers': 'Retained users',
  'pages.marketingCampaigns.firstTimer': 'First timer',
  'pages.marketingCampaigns.organizations':
    'Organizations (type at least 3 characters)',
  'pages.marketingCampaigns.csvOnly': 'Choose a CSV file',
  'pages.marketingCampaigns.csvLimit':
    'Use the first 100,000 users from this file?',
  'pages.marketingCampaigns.template': 'Download template',
  'pages.marketingCampaigns.csvUpload': 'Upload user UUIDs CSV',
  'pages.marketingCampaigns.csvRequirementsTitle':
    'How to prepare your CSV file',
  'pages.marketingCampaigns.csvFileType': 'Upload a .csv file.',
  'pages.marketingCampaigns.csvFirstColumn':
    'Put each eligible user UUID in the first column.',
  'pages.marketingCampaigns.csvOneUserPerRow':
    'Put one eligible user UUID on each row.',
  'pages.marketingCampaigns.csvNonEmptyValues':
    'Every nonempty value in the first column will be imported.',
  'pages.marketingCampaigns.csvSelectPrompt': 'Select a CSV eligibility file',
  'pages.marketingCampaigns.eligibilityValuesLoaded':
    'eligibility value(s) loaded',
  'pages.marketingCampaigns.removeFile': 'Remove file',
  'pages.marketingCampaigns.userCount': 'Number of users',
  'pages.marketingCampaigns.required': 'This field is required',
  'pages.marketingCampaigns.description': 'Description',
  'pages.marketingCampaigns.dateOrder':
    'Expiry must be after the start date and time',
  'pages.marketingCampaigns.budget': 'Budget limit (EGP)',
  'pages.marketingCampaigns.maxUses': 'Campaign usage limit',
  'pages.marketingCampaigns.usesPerUser': 'User usage limit',
  'pages.marketingCampaigns.noLimit': 'No limit',
  'pages.marketingCampaigns.retry': 'Retry',
  'pages.marketingCampaigns.benefits': 'Benefits',
  'pages.marketingCampaigns.configuration': 'Campaign configuration',
  'pages.marketingCampaigns.codeTaken': 'This promo code is already used',
  'pages.marketingCampaigns.compatibility': 'Discount compatibility',
  'pages.marketingCampaigns.override': 'Override',
  'pages.marketingCampaigns.addOnTop': 'Add on top',
  'pages.marketingCampaigns.notCompatible': 'Not compatible',
  'pages.marketingCampaigns.fixed': 'Fixed amount (EGP)',
  'pages.marketingCampaigns.percentage': 'Percentage',
  'pages.marketingCampaigns.slotsRequired': 'Choose at least one eligible slot',
  'pages.marketingCampaigns.monthsRequired': 'Choose discounted months',
  'pages.marketingCampaigns.discountedMonths': 'Discounted months',
  'pages.marketingCampaigns.eligibleSlots': 'Eligible slots',
  'pages.marketingCampaigns.amountFrom': 'Minimum circle amount',
  'pages.marketingCampaigns.amountTo': 'Maximum circle amount',
  'pages.marketingCampaigns.amountOrder':
    'Choose both amount bounds with minimum ≤ maximum',
  'pages.marketingCampaigns.codeMode': 'Promo code type',
  'pages.marketingCampaigns.generated': 'Auto-generated codes',
  'pages.marketingCampaigns.specific': 'Specific code',
  'pages.marketingCampaigns.prefix': 'Prefix',
  'pages.marketingCampaigns.codeCount': 'Number of codes',
  'pages.marketingCampaigns.codeLength': 'Promo code must have 5–15 characters',
  'pages.marketingCampaigns.back': 'Back to campaigns',
  'pages.marketingCampaigns.previous': 'Previous',
  'pages.marketingCampaigns.next': 'Next',
  'pages.marketingCampaigns.save': 'Save',
  'pages.marketingCampaigns.details': 'Campaign details',
  'pages.marketingCampaigns.multipleCodes': 'Multiple codes',
  'pages.marketingCampaigns.none': 'No benefit',
  'pages.marketingCampaigns.budgetUsed': 'Budget used (EGP)',
  'pages.marketingCampaigns.actualUses': 'Actual uses',
};
